"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const appContext_1 = require("../appContext");
function useTranslation() {
    const { defaultLang } = (0, appContext_1.useAppContext)();
    const { formatMessage, locale } = (0, react_intl_1.useIntl)();
    const translate = (0, react_1.useCallback)((id, values) => formatMessage({ id }, values), [formatMessage]);
    const t = (0, react_1.useCallback)((arg, values) => typeof arg === 'function'
        ? (...args) => {
            const id = arg(...args);
            if (id !== undefined) {
                return translate(id);
            }
        }
        : arg === undefined
            ? undefined
            : translate(arg, values), [translate]);
    const colon = (0, react_1.useCallback)((arg, values) => {
        const txt = t(arg, values);
        const colonSign = locale === 'fr' ? ' :' : ':';
        return typeof txt === 'string' ? (`${txt}${colonSign}`) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [txt, colonSign] }));
    }, [t, locale]);
    t.colon = colon;
    return (0, react_1.useMemo)(() => ({ t, locale: locale, defaultLang }), [t, locale, defaultLang]);
}
exports.useTranslation = useTranslation;
